<template>
  <layout-main-inner
    showBack
    :title="$route.meta.name+ `(${config.vendorName}-${config.certName})`">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">新增证书文件</el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-button
          type="primary"
          @click="fetchList">刷新</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="证书图片"
          min-width="300px">
          <template slot-scope="{row}">
            <image-list
              :list="row.certFile"
              style="--image-width:48px;--image-height: 48px" />
          </template>
        </el-table-column>
        <el-table-column
          label="证书编号"
          prop="certNo"
          min-width="140"> </el-table-column>
        <el-table-column
          label="出证日期"
          prop="issuanceTime"
          min-width="120"><template slot-scope="{row}">{{ row.issuanceTime | dateformat('YYYY-MM-DD') }}</template>
        </el-table-column>
        <el-table-column
          label="有效期"
          min-width="160">
          <template slot-scope="{row}">{{ row.certBeginTime | dateformat('YYYY-MM-DD') }} ~ {{ row.certEndTime | dateformat('YYYY-MM-DD') }}</template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="60">
          <template slot-scope="{ row }">
            <!-- <el-button
              type="text"
              @click="updateitem(row)"> 编辑证书文件 </el-button> -->
            <el-button
              type="text"
              @click="deleteitem(row)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </layout-card-wrap>
    <certificate-file-modal
      ref="modal"
      @fetch="fetchList" />
  </layout-main-inner>
</template>
<script>
import ImageList from '../../../components/image-list.vue'
import CertificateFileModal from './certificate-file-modal.vue'
export default {
  name: 'CertificateFile',
  components: { CertificateFileModal, ImageList },
  data() {
    return {
      loading: true,
      list: [],
      config: { vendorName: '', vendorId: null, certName: '', certId: null }
    }
  },
  mounted() {
    this.config = { ...this.config, ...this.$route.query }
    this.fetchList()
  },
  methods: {
    additem() {
      const { certId, certName } = this.config
      this.$refs.modal.init({ certId, certName })
    },
    updateitem(row) {
      const { certId, certName } = this.config
      const { certFileId, certFile, certBeginTime, certEndTime } = row
      const time = [new Date(certBeginTime), new Date(certEndTime)]
      this.$refs.modal.init({ certId, certName, certFileId, certFile, time })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该证书文件?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$CommonApi.deletecertificatefile({ certFileId: row.certFileId, vendorId: this.config.vendorId, certId: row.certId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.loading = false
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    fetchList() {
      this.loading = true
      this.$$CommonApi.getcertificate(this.config)
        .then(res => {
          this.loading = false
          const { result, message, certFiles } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.list = certFiles.map(i => ({ ...i, certFile: this.$splitImage(i.certFile) }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
